import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppState, JobIncidentMediaFacadeBase } from '@app/state';
import { Store, select } from '@ngrx/store';
import { JobIncidentMedia } from '@app/models';
import {
  CreateJobIncidentMediaRequest,
  createJobIncidentMedia,
} from '@app/state/job-incident-media.effects';
import { JobIncidentMediaService } from '@services/api/job-incident-media.service';
import { selectJobIncidentVMMediaByIncident } from '@app/state/job-incident-media.join-selectors';

@Injectable({ providedIn: 'root' })
export class JobIncidentMediaFacade extends JobIncidentMediaFacadeBase {
  constructor(
    private store: Store<AppState>,
    private mediaService: JobIncidentMediaService
  ) {
    super(JobIncidentMedia, store);
  }

  imageLink$(media: JobIncidentMedia): Observable<string> {
    return this.mediaService.getLink(media.id);
  }

  createMedia(payload: CreateJobIncidentMediaRequest) {
    this.store.dispatch(createJobIncidentMedia({ payload }));
  }

  get mediaByIncident$() {
    return this.store.pipe(select(selectJobIncidentVMMediaByIncident));
  }
}
